import { ContentViewModel } from '@levelapp/softfabric';
export default class TableViewModel extends ContentViewModel {
    constructor(view) {
        super(view);
        this.imageDesc = require('./assets/sort_desc.png');
        this.imageAsc = require('./assets/sort_asc.png');
        this.image = require('./assets/sort.png');
        var tmp = "asc";
        if (this.props().defaultSortDesc != undefined && this.props().defaultSortDesc) {
            tmp = "desc";
        }
        this.initialState({
            currentPage: 0,
            currentSort: tmp,
            defaultSortDesc: this.props().defaultSortDesc,
            image: this.image,
            imageSort: undefined,
            sortIndice: -1,
            currentArray: (this.props().data != undefined && this.props().data.length > 0) ? this.props().data.slice(0) : [],
            initialArrayState: (this.props().data != undefined && this.props().data.length > 0) ? this.props().data : [],
        });
        this.OnPress = this.OnPress.bind(this);
        this.sort = this.sort.bind(this);
        this.changePage = this.changePage.bind(this);
    }
    /* METHODS */
    getCurrentArray() {
        if (this.props().data != this.state().initialArrayState) {
            this.setField({ currentArray: this.props().data.slice(0), initialArrayState: this.props().data });
            return [];
        }
        else {
            return this.state().currentArray;
        }
    }
    /* PAGING */
    getPages() {
        var tmp = this.getCurrentArray();
        if (tmp != undefined && tmp.length > 0) {
            return Math.ceil(tmp.length / this.props().numberItemsPerPage);
        }
        else {
            return 1;
        }
    }
    /* Paging */
    getElementsForPage() {
        // Slice Whithout Researching
        var page = this.getCurrentArray();
        if (page != undefined && page.length > 0) {
            page = page.slice(this.state().currentPage * this.props().numberItemsPerPage, (this.state().currentPage + 1) * this.props().numberItemsPerPage);
        }
        return page;
    }
    Researching(txt) {
        if (txt == '' || txt == undefined) {
            this.setField({ isResearching: false, currentArray: this.state().initialArrayState.slice(0) });
        }
        else {
            if (this.state().initialArrayState != undefined && this.state().initialArrayState.length > 0) {
                this.changePage(0);
                this.setField({ isResearching: true, currentArray: this.state().initialArrayState.filter(x => {
                        return x.data.toString().toLocaleLowerCase().includes(txt.toLocaleLowerCase());
                    })
                });
            }
            else {
                this.setField({ isResearching: true });
            }
        }
    }
    ClosingResearch() {
        this.setField({ isResearching: false, currentArray: this.state().initialArrayState.slice(0) });
    }
    changePage(nextPage) {
        this.setField({ currentPage: nextPage });
    }
    OnPress(key) {
        if (key != this.state().sortIndice) {
            if (this.props().defaultSortDesc != undefined && this.props().defaultSortDesc) {
                this.setField({ currentSort: 'desc', sortIndice: key, imageSort: this.imageDesc }, () => this.sort());
            }
            else {
                this.setField({ currentSort: 'asc', sortIndice: key, imageSort: this.imageAsc }, () => this.sort());
            }
        }
        else {
            this.setField({ sortIndice: key });
            if (this.props().defaultSortDesc != undefined && this.props().defaultSortDesc) {
                //First 
                //Desc - Asc - Default
                if (this.state().currentSort == 'desc') {
                    this.setField({ currentSort: 'asc', sortIndice: key, imageSort: this.imageAsc }, () => this.sort());
                }
                else if (this.state().currentSort == 'asc') {
                    this.setField({ currentSort: 'default', sortIndice: key, imageSort: this.image }, () => this.sort());
                }
                else if (this.state().currentSort == 'default') {
                    this.setField({ currentSort: 'desc', sortIndice: key, imageSort: this.imageDesc }, () => this.sort());
                }
            }
            else {
                //Second
                //Asc - Desc - Default
                if (this.state().currentSort == 'desc') {
                    this.setField({ currentSort: 'default', sortIndice: key, imageSort: this.image }, () => this.sort());
                }
                else if (this.state().currentSort == 'asc') {
                    this.setField({ currentSort: 'desc', sortIndice: key, imageSort: this.imageDesc }, () => this.sort());
                }
                else if (this.state().currentSort == 'default') {
                    this.setField({ currentSort: 'asc', sortIndice: key, imageSort: this.imageAsc }, () => this.sort());
                }
            }
        }
    }
    sort() {
        if (this.props().isSortable && this.state().sortIndice != -1) {
            //DESC-ASC-DEFAULT
            if (this.state().defaultSortDesc != undefined && this.state().defaultSortDesc && this.state().currentSort == 'asc') {
                this.setField({ arrayData: this.state().currentArray.sort((a, b) => { return a.data[this.state().sortIndice] < b.data[this.state().sortIndice] ? -1 : 1; }).slice(this.state().currentPage * this.props().numberItemsPerPage, (this.state().currentPage + 1) * this.props().numberItemsPerPage) });
            }
            else if (this.state().defaultSortDesc != undefined && this.state().defaultSortDesc && this.state().currentSort == 'desc') {
                this.setField({ arrayData: this.state().currentArray.sort((a, b) => { return a.data[this.state().sortIndice] > b.data[this.state().sortIndice] ? -1 : 1; }).slice(this.state().currentPage * this.props().numberItemsPerPage, (this.state().currentPage + 1) * this.props().numberItemsPerPage) });
            }
            else if (this.state().defaultSortDesc != undefined && this.state().defaultSortDesc && this.state().currentSort == 'default') {
                this.setField({ currentArray: this.state().initialArrayState.slice(0) });
            }
            //ASC-DESC-DEFAULT
            if ((this.state().defaultSortDesc == undefined || this.state().defaultSortDesc == false) && this.state().currentSort == 'asc') {
                this.setField({ arrayData: this.state().currentArray.sort((a, b) => { return a.data[this.state().sortIndice] < b.data[this.state().sortIndice] ? -1 : 1; }).slice(this.state().currentPage * this.props().numberItemsPerPage, (this.state().currentPage + 1) * this.props().numberItemsPerPage) });
            }
            else if ((this.state().defaultSortDesc == undefined || this.state().defaultSortDesc == false) && this.state().currentSort == 'desc') {
                this.setField({ arrayData: this.state().currentArray.sort((a, b) => { return a.data[this.state().sortIndice] > b.data[this.state().sortIndice] ? -1 : 1; }).slice(this.state().currentPage * this.props().numberItemsPerPage, (this.state().currentPage + 1) * this.props().numberItemsPerPage) });
            }
            else if ((this.state().defaultSortDesc == undefined || this.state().defaultSortDesc == false) && this.state().currentSort == 'default') {
                this.setField({ currentArray: this.state().initialArrayState.slice(0) });
            }
        }
    }
}
